import { render, staticRenderFns } from "./PodcastElement.vue?vue&type=template&id=642bf1fd&"
import script from "./PodcastElement.vue?vue&type=script&lang=js&"
export * from "./PodcastElement.vue?vue&type=script&lang=js&"
import style0 from "./PodcastElement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports